import { client } from './index';
// Cursor estable por ID: se recorren todas las páginas, también al exportar.
export async function ticketPages(url) {
  const rows = []; let before;
  for (;;) {
    const { data } = await client.get(url, { params: before ? { before } : {} });
    rows.push(...data);
    if (data.length < 200) return rows;
    const next = data[data.length - 1]._id;
    if (next === before) throw new Error('No se pudo completar la paginación');
    before = next;
  }
}
